module.exports = __webpack_public_path__ + "static/media/animal-dog8.045a1ec3.aac";